export const FREE_AND_STARTER_DEAL_SCP_LOCKDOWN = 'free-and-starter-deal-scp-lockdown';